module.exports = __webpack_public_path__ + "static/img/grid.556299a8.png";